import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, inr, fmtErr } from "@/lib/api";
import { ArrowLeft, Plus, Minus } from "lucide-react";
import { toast } from "sonner";

export default function GuestServicesPage() {
  const [services, setServices] = useState([]);
  const [qty, setQty] = useState({});
  const [busy, setBusy] = useState(null);

  useEffect(() => { http.get("/guest/services").then((r) => setServices(r.data.services)); }, []);

  const submit = async (s) => {
    const q = qty[s.id] || 1;
    setBusy(s.id);
    try {
      await http.post("/guest/service-requests", { service_id: s.id, quantity: q });
      toast.success(`${s.name} requested — staff notified`);
      setQty((p) => ({ ...p, [s.id]: 1 }));
    } catch (e) { toast.error(fmtErr(e)); } finally { setBusy(null); }
  };

  return (
    <div className="min-h-screen pb-20" style={{ background: "var(--surface)" }}>
      <div className="max-w-lg mx-auto px-4 pt-6">
        <Link to="/guest/dashboard" data-testid="services-back" className="flex items-center gap-1 text-sm mb-4" style={{ color: "var(--muted)" }}><ArrowLeft size={16} /> Back</Link>
        <div className="eyebrow mb-1">Villa Concierge</div>
        <h1 className="font-serif text-4xl mb-6">Request a Service</h1>
        <div className="space-y-3">
          {services.map((s) => {
            const q = qty[s.id] || 1;
            return (
              <div key={s.id} className="card" data-testid={`service-${s.name.toLowerCase().replace(/\s/g, "-")}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1">
                    <div className="font-serif text-xl">{s.name}</div>
                    <div className="text-sm mb-2" style={{ color: "var(--muted)" }}>{s.description}</div>
                    <div className="font-medium">{inr(s.price)} <span className="text-xs" style={{ color: "var(--muted)" }}>/ {s.unit}</span></div>
                  </div>
                </div>
                <div className="flex items-center justify-between mt-3">
                  <div className="flex items-center gap-2">
                    <button data-testid={`svc-dec-${s.id}`} onClick={() => setQty((p) => ({ ...p, [s.id]: Math.max(1, q - 1) }))} className="w-8 h-8 rounded-full border flex items-center justify-center"><Minus size={14} /></button>
                    <span className="w-6 text-center">{q}</span>
                    <button data-testid={`svc-inc-${s.id}`} onClick={() => setQty((p) => ({ ...p, [s.id]: q + 1 }))} className="w-8 h-8 rounded-full border flex items-center justify-center"><Plus size={14} /></button>
                  </div>
                  <button data-testid={`svc-req-${s.id}`} disabled={busy === s.id} onClick={() => submit(s)} className="btn-primary" style={{ padding: "10px 18px", fontSize: 14 }}>{busy === s.id ? "…" : "Request"}</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
